import { makeObservable, observable } from 'mobx';
import SituacaoAlteracaoMinutaBusiness from '../../dominio/SituacaoAlteracaoMinutaBusiness';
import StatusMinuta from '../sessao/StatusMinuta';
import { Filtro } from './Filtro';
import SituacaoAlteracaoMinuta, { SITUACAO_ALTERACAO_MINUTA } from '@/dominio/SituacaoAlteracaoMinuta';
import { Sync, SyncProblem } from '@mui/icons-material';

export default class FiltroSituacaoMinuta extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';

    constructor(props) {
        super(props);

        makeObservable(this, {
            filtroRapido: observable
        });
    }

    get label() {
        return 'Alteração de minuta de voto';
    }

    getIconeFiltroRapido() {
        return <SyncProblem />;
    }

    opcoesFiltro = FiltroSituacaoMinuta.#carregarOpcoes();

    filtroRapido = {
        opcoes: this.getOpcoesFiltro('valor', 'cor')
    };

    static #carregarOpcoes() {
        return [
            {
                valor: SITUACAO_ALTERACAO_MINUTA.ALTERADA.id,
                cor: SITUACAO_ALTERACAO_MINUTA.ALTERADA.cor,
                icone: (
                    <SyncProblem
                        style={{
                            fill: SITUACAO_ALTERACAO_MINUTA.ALTERADA.cor
                        }}
                    />
                )
            },
            {
                valor: SITUACAO_ALTERACAO_MINUTA.ALTERACAO_EMENTA_EOU_DECISAO_ANALISADAS.id,
                cor: SITUACAO_ALTERACAO_MINUTA.ALTERACAO_EMENTA_EOU_DECISAO_ANALISADAS.cor,
                icone: (
                    <Sync
                        style={{
                            fill: SITUACAO_ALTERACAO_MINUTA.ALTERACAO_EMENTA_EOU_DECISAO_ANALISADAS.cor
                        }}
                    />
                )
            },
            {
                valor: SITUACAO_ALTERACAO_MINUTA.ALTERACAO_ANALISADA.id,
                cor: SITUACAO_ALTERACAO_MINUTA.ALTERACAO_ANALISADA.cor,
                icone: (
                    <Sync
                        style={{
                            fill: SITUACAO_ALTERACAO_MINUTA.ALTERACAO_ANALISADA.cor
                        }}
                    />
                )
            },
            {
                valor: SITUACAO_ALTERACAO_MINUTA.EMENTA_EOU_DECISAO_ALTERADAS.id,
                cor: SITUACAO_ALTERACAO_MINUTA.EMENTA_EOU_DECISAO_ALTERADAS.cor,
                icone: (
                    <SyncProblem
                        style={{
                            fill: SITUACAO_ALTERACAO_MINUTA.EMENTA_EOU_DECISAO_ALTERADAS.cor
                        }}
                    />
                )
            }
        ];
    }

    getValorOpcao(registro) {
        let valores = [];
        let statusMinuta = SituacaoAlteracaoMinutaBusiness.getStatusMinuta(registro);

        if (statusMinuta?.id === SITUACAO_ALTERACAO_MINUTA.ALTERADA.id) {
            valores.push(SITUACAO_ALTERACAO_MINUTA.ALTERADA.id);
        } else if (statusMinuta?.id === SITUACAO_ALTERACAO_MINUTA.ALTERACAO_EMENTA_EOU_DECISAO_ANALISADAS.id) {
            valores.push(SITUACAO_ALTERACAO_MINUTA.ALTERACAO_EMENTA_EOU_DECISAO_ANALISADAS.id);
        } else if (statusMinuta?.id === SITUACAO_ALTERACAO_MINUTA.ALTERACAO_ANALISADA.id) {
            valores.push(SITUACAO_ALTERACAO_MINUTA.ALTERACAO_ANALISADA.id);
        } else if (statusMinuta?.id === SITUACAO_ALTERACAO_MINUTA.EMENTA_EOU_DECISAO_ALTERADAS.id) {
            valores.push(SITUACAO_ALTERACAO_MINUTA.EMENTA_EOU_DECISAO_ALTERADAS.id);
        }
        return valores;
    }

    // eslint-disable-next-line no-unused-vars
    getIconeOpcao(registro, valor) {
        return (
            <StatusMinuta
                apenasIcone
                registro={registro}
            />
        );
    }

    getDescricao(valor) {
        return SituacaoAlteracaoMinuta.getDescricao(valor);
    }
}
